

























































































































import { Component, Vue } from 'vue-property-decorator';
import gql from 'graphql-tag';
import Loading from '@/components/Loading.vue';
import { formattedDateStringTz } from '@/utils/date';
import DateRangeSelector from '@/components/DateRangeSelector.vue';

@Component({
  components: {
    Loading,
    DateRangeSelector,
  },
})
export default class Reports extends Vue {
  public userReportQuery = gql`
    query UserReport($startDateTime: DateTime, $endDateTime: DateTime) {
      userReport(startDateTime: $startDateTime, endDateTime: $endDateTime) {
        user {
          id
          email
          name
          createdAt
        }
        points
      }
    }
  `;

  public reportQuery = gql`
    query Reports($ids: [ID], $startDateTime: DateTime, $endDateTime: DateTime) {
      centers(ids: $ids) {
        id
        centerCode
        name
        phone
        stateOrProvince
        city
        timeZone
        report(startDateTime: $startDateTime, endDateTime: $endDateTime) {
          totalGamesPlayed
          totalPlayers
          gamesPerLane {
            lane
            count
          }
          gamesPlayed {
            game
            count
          }
          games {
            gameType
            startedAt
            endedAt
            lanes
            bowlerNames
            finalScoreHome
            finalScoreVisitor
          }
        }
      }
    }
  `;
  public reportQueryVariables = {
    startDateTime: null as Date | null,
    endDateTime: null as Date | null,
  };
  public userReportQueryVariables = {
    startDateTime: null as Date | null,
    endDateTime: null as Date | null,
  };

  public centers: any[] | null = null;

  public getGamesSummaryByCenterURI(centers: any[] | null) {
    if (!centers) { return ''; }

    const esc = (str?: string) => (str || '').replace(/('|")/gi, (c) => `\\${c}`);
    const heading = 'code,name,state,city,phone,total_games,total_players';

    const body = centers.map((c) =>
      `"${esc(c.centerCode)}",` +
      `"${esc(c.name)}",` +
      `"${esc(c.stateOrProvince)}",` +
      `"${esc(c.city)}",` +
      `"${esc(c.phone)}",` +
      `${c.report.totalGamesPlayed},` +
      `${c.report.totalPlayers}`,
    ).join('\n');

    const csv = `${heading}\n${body}`;

    return `data:text/csv;charset=UTF-8,\uFEFF${encodeURIComponent(csv)}`;
  }

  public getGamesByCenterURI(centers: any[] | null) {
    if (!centers) { return ''; }

    const esc = (str?: string) => (str || '').replace(/('|")/gi, (c) => `\\${c}`);
    const heading = 'code,name,game,started_at,started_at_local,ended_at,' +
      'ended_at_local,lanes,bowler_names,final_score_home,final_score_visitor';

    const body = centers.flatMap((c) =>
      ((c.report || {}).games || []).map((g: any) =>
        `"${esc(c.centerCode)}",` +
        `"${esc(c.name)}",` +
        `"${esc(g.gameType)}",` +
        `"${esc(g.startedAt)}",` +
        `"${esc(formattedDateStringTz(g.startedAt, c.timeZone))}",` +
        `"${esc(g.endedAt)}",` +
        `"${esc(formattedDateStringTz(g.endedAt, c.timeZone))}",` +
        `"${esc((g.lanes || []).join(','))}",` +
        `"${esc((g.bowlerNames || []).join(','))}",` +
        `"${g.finalScoreHome === null ? '' : g.finalScoreHome}",` +
        `"${g.finalScoreVisitor === null ? '' : g.finalScoreVisitor}"`,
      ),
    ).join('\n');

    const csv = `${heading}\n${body}`;

    return `data:text/csv;charset=UTF-8,\uFEFF${encodeURIComponent(csv)}`;
  }

  public getUserReportURI(users: any[] | null) {
    if (!users) { return ''; }

    const esc = (str?: string) => (str || '').replace(/('|")/gi, (c) => `\\${c}`);
    const heading = 'name,email,signup_date,points';

    const body = users.map((u) =>
      `"${esc(u.user.name)}",` +
      `"${esc(u.user.email)}",` +
      `"${esc(u.user.createdAt)}",` +
      `"${u.points}",`,
    ).join('\n');

    const csv = `${heading}\n${body}`;

    return `data:text/csv;charset=UTF-8,\uFEFF${encodeURIComponent(csv)}`;
  }

  public onRangeSelected(query: any, [start, end]: [Date, Date]) {
    this.reportQueryVariables = {
      startDateTime: start || null,
      endDateTime: end || null,
    };
    query.refetch(this.reportQueryVariables);
  }

  public onUserRangeSelected(query: any, [start, end]: [Date, Date]) {
    this.userReportQueryVariables = {
      startDateTime: start || null,
      endDateTime: end || null,
    };
    query.refetch(this.userReportQueryVariables);
  }
}
